/* Keep the PDP purchase bar above the footer without moving its product form. */
(() => {
  function init() {
    const bar = document.querySelector('[data-footer-sticky], .sticky-cart-wrapper');
    const footer = document.querySelector('#pagefooter .section-footer, footer.footer');
    if (!bar || !footer || bar.dataset.footerDock) return;
    bar.dataset.footerDock = 'true';
    const spacer = document.createElement('div');
    spacer.className = 'sticky-cart-footer-space';
    spacer.setAttribute('aria-hidden', 'true');
    footer.before(spacer);

    const isCustom = bar.hasAttribute('data-footer-sticky');
    const section = bar.closest('.shopify-section') || document.querySelector('product-info') || document;
    const sourceButton = isCustom && section.querySelector('.add-to-cart-section .add-to-cart-btn, button[id^="ProductSubmitButton-"]');
    let stickyButton = bar.querySelector('[data-sticky-purchase]');
    const priceContainer = isCustom && section.querySelector('.maison_price_container');
    let drawerOpen = false;
    let frame = 0;

    function setText(element, value) {
      if (element && element.textContent !== value) element.textContent = value;
    }
    function syncPurchase() {
      stickyButton = bar.querySelector('[data-sticky-purchase]');
      if (!stickyButton) return;
      stickyButton.disabled = !sourceButton || sourceButton.disabled;
      const sourceLabel = sourceButton && sourceButton.querySelector('span[x-text], span');
      setText(stickyButton, stickyButton.disabled && sourceLabel ? sourceLabel.textContent.trim() : stickyButton.dataset.addLabel);
      if (priceContainer) {
        const current = priceContainer.querySelector('.maison_price_current');
        const compare = priceContainer.querySelector('.maison_price_compare');
        const stickyCompare = bar.querySelector('[data-sticky-compare]');
        if (current) setText(bar.querySelector('[data-sticky-price]'), current.textContent.trim());
        if (stickyCompare) {
          stickyCompare.hidden = !compare || getComputedStyle(compare).display === 'none';
          if (compare) setText(stickyCompare, compare.textContent.trim());
        }
      }
    }
    function update() {
      frame = 0;
      syncPurchase();
      const height = Math.ceil(bar.getBoundingClientRect().height);
      const space = `${height}px`;
      if (spacer.style.height !== space) spacer.style.height = space;
      const footerTop = footer.getBoundingClientRect().top;
      const offset = Math.min(0, footerTop - window.innerHeight);
      bar.style.setProperty('--sticky-cart-footer-offset', `${offset}px`);
      const drawer = document.querySelector('cart-drawer.active');
      const open = drawerOpen || !!drawer || document.documentElement.classList.contains('js-ajax-cart-drawer-opened');
      const eligible = isCustom
        ? !!sourceButton && sourceButton.getBoundingClientRect().bottom <= 0
        : window.scrollY > (window.innerWidth <= 768 ? 1000 : 300);
      const active = eligible && !open && footerTop > 0;
      bar.dataset.footerActive = String(active);
      bar.setAttribute('aria-hidden', String(!active));
      bar.inert = !active;
      const chatClearance = active && offset > -100 ? `${height - offset}px` : '0px';
      document.documentElement.style.setProperty('--pdp-sticky-chat-clearance', chatClearance);
    }
    function schedule() {
      if (!frame) frame = window.requestAnimationFrame(update);
    }
    if (stickyButton) bar.addEventListener('click', (event) => {
      if (!event.target.closest('[data-sticky-purchase]')) return;
      if (sourceButton && !sourceButton.disabled) {
        sourceButton.click();
        schedule();
      }
    });
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('load', schedule);
    document.addEventListener('on:cart-drawer:after-open', () => { drawerOpen = true; schedule(); });
    document.addEventListener('on:cart-drawer:after-close', () => { drawerOpen = false; schedule(); });
    document.addEventListener('maison:variantChange', schedule);
    document.addEventListener('on:variant:change', schedule);
    new MutationObserver(schedule).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    const drawer = document.querySelector('cart-drawer');
    if (drawer) new MutationObserver(schedule).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    if (sourceButton) new MutationObserver(schedule).observe(sourceButton, { attributes: true, attributeFilter: ['disabled'], childList: true, subtree: true, characterData: true });
    if (priceContainer) new MutationObserver(schedule).observe(priceContainer, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['style'] });
    if ('ResizeObserver' in window) {
      const observer = new ResizeObserver(schedule);
      observer.observe(bar);
      observer.observe(document.body);
      const main = document.querySelector('main');
      if (main) observer.observe(main);
    }
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
